export const BRAND_PROPERTY_TYPES = {
  GLOBAL_PRICE_PROPERTY_TYPE: 'GLOBAL_PRICE',
};

export const BRAND_PROPERTIES = {
  GLOBAL_PRICE_EFFECTIVE_DATE: 'GLOBAL_PRICE_EFFECTIVE_DATE',
};
